import React, { useEffect, useState } from 'react';
import { isMobile } from 'is-mobile';
import { Entry } from '../../types';

interface VoteButtonProps {
    entry: Entry;
}
export const VoteButton: React.FC<VoteButtonProps> = ({ entry }) => {
    const [url, setUrl] = useState<string>(`${process.env.REACT_APP_VOTE_NEW_URL}/${entry.entry_id}`);

    useEffect(() => {
        setUrl(
            isMobile()
                ? `${process.env.REACT_APP_VOTE_NEW_URL}/${entry.entry_id}`
                : `${process.env.REACT_APP_VOTE_URL}/${entry.entry_id}?callback=${process.env.REACT_APP_URL}/entry/${entry.entry_id}`,
        );
    }, [entry.entry_id]);

    return (
        <div className="has-text-centered is-margin-bottom-1">
            <a className="button is-fullwidth is-gorgeous is-medium" href={url}>
                <span>WEB投票</span>
            </a>
        </div>
    );
};